import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import cloneDeep from 'lodash.clonedeep';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Label,
  Button,
  FormGroup,
  UncontrolledTooltip,
  Pagination,
  PaginationItem,
  PaginationLink
} from 'reactstrap';
import AvForm from 'availity-reactstrap-validation/lib/AvForm';
import AvField from 'availity-reactstrap-validation/lib/AvField';

import PageTitle from '../../components/Common/PageTitle';
import { SetStatusStyle, ShowNotification } from '../../helpers/general/generalHelpers';
import Loader from '../../shared/loader/loader';
import { getListStudyGuides } from '../../service/studyGuide';
import { getListSubjects } from '../../service/subject';
import { getListChapter } from '../../service/chapter';
import PopupAddStudyGuide from './PopupAddStudyGuide';

import { getPaginationInformation, initialPaginationObject } from '../../helpers/general/pagination';

const StudyGuideList = (props) => {
  const [pagination, setPagination] = useState(initialPaginationObject);
  const filterForm = useRef(null);
  const [filters, setFilters] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [studyGuides, setStudyGuides] = useState([]);
  const [loader, setLoader] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [chaptersAll, setchaptersAll] = useState([]);

  if (props.location.notification && props.location.notification.show) {
    const notification = props.location.notification;
    ShowNotification({
      type: 'success',
      message: notification.message
    });
    props.location.notification = null;
  }

  const handleGetSubjects = () => {
    getListSubjects({ pageSize: 100 })
      .then((response) => {
        const subjList = response.data.subjects.map((subj) => {
          return { ...subj, id: subj._id, value: subj.title, label: subj.title };
        });
        setSubjects(subjList);
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleGetChapter = () => {
    getListChapter({ pageSize: 999999 })
      .then((response) => {
        const chapList = response.data.chapters.map((chap) => {
          return { ...chap, id: chap._id, value: chap.title, label: chap.title };
        });
        setChapters(chapList);
        setchaptersAll(chapList);
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleGetListStudyGuides = () => {
    setLoader(true);
    getListStudyGuides({ pageNumber: currentPage, filters })
      .then((response) => {
        setStudyGuides(response.data.studyGuides);
        setPagination(getPaginationInformation(response.data.Count, currentPage));
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const clearFilters = () => {
    filterForm.current.reset();
    setFilters(undefined);
  };

  const handleFilters = (event, values) => {
    setFilters(values);
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const toggleModal = () => {
    setIsPopupOpen(!isPopupOpen);
    removeBodyCss();
  };

  const removeBodyCss = () => {
    document.body.classList.add('no_padding');
  };

  const onChangeSubject = (e) => {
    if (e.target.value) {
      const chapterFilter = cloneDeep(chaptersAll).filter((c) => c?.subjectId?.title === e.target.value);
      setChapters(chapterFilter);
    } else {
      setChapters(chaptersAll);
    }
  };

  useEffect(() => {
    handleGetSubjects();
    handleGetChapter();
  }, []);

  useEffect(() => {
    handleGetListStudyGuides();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, filters]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="relative">
          <Loader loading={loader} />

          {/* Render Page title */}
          <PageTitle title="Study Guides">
            <div className="page-title-right">
              <Button
                onClick={(e) => {
                  setIsPopupOpen(true);
                }}
                className="btn btn-primary btn-block agora-button border-radius waves-effect waves-light"
              >
                + Add New Study Guide
              </Button>
            </div>
          </PageTitle>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <AvForm
                    ref={filterForm}
                    onValidSubmit={(e, v) => {
                      handleFilters(e, v);
                    }}
                  >
                    <Row>
                      <Col className="col-sm-2">
                        <FormGroup>
                          <Label>Title :</Label>
                          <AvField name="title" placeholder="Search" className="form-control filter-field" />
                        </FormGroup>
                      </Col>
                      <Col className="col-sm-2">
                        <FormGroup>
                          <Label>Subject :</Label>
                          <AvField
                            type="select"
                            name="subject"
                            className="form-control filter-field"
                            onChange={onChangeSubject}
                          >
                            <option value="">Please select the subject</option>
                            {subjects.map((subj, idx) => {
                              return (
                                <option key={idx} value={subj.title}>
                                  {subj.title + ' - ' + subj.studyLevelId}
                                </option>
                              );
                            })}
                          </AvField>
                        </FormGroup>
                      </Col>
                      <Col className="col-sm-2">
                        <FormGroup>
                          <Label>Chapter :</Label>
                          <AvField type="select" name="chapter" className="form-control filter-field">
                            <option value="">Please select the chapter</option>
                            {chapters.map((subj, idx) => {
                              return (
                                <option key={idx} value={subj.title}>
                                  {' '}
                                  {subj.title}{' '}
                                </option>
                              );
                            })}
                          </AvField>
                        </FormGroup>
                      </Col>
                      <Col className="col-sm-2">
                        <FormGroup>
                          <Label>Status :</Label>
                          <AvField type="select" name="active" className="form-control filter-field">
                            <option value="">Please select the status</option>
                            <option key={1} value={true}>
                              {' '}
                              Active
                            </option>
                            <option key={2} value={false}>
                              {' '}
                              Inactive
                            </option>
                          </AvField>
                        </FormGroup>
                      </Col>
                      <Col className="col-sm-3 mb-4" style={{ paddingTop: '27px' }}>
                        <Button
                          type="submit"
                          className="btn btn-primary agora-button save-button border-radius waves-effect waves-light"
                        >
                          Filter
                        </Button>
                        <Button
                          type="button"
                          onClick={clearFilters}
                          className="btn btn-primary agora-button cancel-button border-radius waves-effect waves-light ml-2"
                        >
                          Clear
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <Table className="table-centered table-nowrap table-hover">
                      <thead className="thead-light font-size-15">
                        <tr>
                          <th scope="col">Title</th>
                          <th scope="col">Subject</th>
                          <th scope="col">Chapter</th>
                          <th scope="col">Status</th>
                          <th scope="col" className="text-center">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className="agora-lato">
                        {studyGuides.map((studyGuide, i) => (
                          <tr key={'_studyguide_' + studyGuide._id}>
                            <td>
                              <span>
                                <Link
                                  style={{ color: '#495057' }}
                                  to={{
                                    pathname: '/studyguide',
                                    search: '?id=' + studyGuide._id
                                  }}
                                  id={'_studyguide_' + studyGuide._id}
                                >
                                  {studyGuide.title}
                                  <UncontrolledTooltip placement="top" target={'_studyguide_' + studyGuide._id}>
                                    View
                                  </UncontrolledTooltip>
                                </Link>
                              </span>
                            </td>
                            <td>
                              {studyGuide.subject?.title} - {studyGuide?.studyLevelId}
                            </td>
                            <td>{studyGuide.chapter?.title}</td>
                            <td>
                              <div>
                                <SetStatusStyle status={studyGuide.active ? 'active' : 'inactive'} />
                              </div>
                            </td>
                            <td className="text-center">
                              <ul className="list-inline font-size-20 contact-links mb-0">
                                <li className="list-inline-item px-2">
                                  <Link
                                    to={{ pathname: '/studyguide', search: '?id=' + studyGuide._id }}
                                    id={'view-studyguide' + studyGuide._id}
                                  >
                                    <i className="bx bx-show-alt"></i>
                                    <UncontrolledTooltip placement="top" target={'view-studyguide' + studyGuide._id}>
                                      View / Edit
                                    </UncontrolledTooltip>
                                  </Link>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <Row>
                    <Col lg="12">
                      <Pagination className="pagination pagination-rounded justify-content-center mt-4">
                        <PaginationItem disabled={pagination.currentPage === 1}>
                          <PaginationLink
                            first
                            onClick={(e) => {
                              paginate(1);
                            }}
                          />
                        </PaginationItem>
                        <PaginationItem disabled={pagination.currentPage === 1}>
                          <PaginationLink
                            previous
                            onClick={(e) => {
                              paginate(pagination.currentPage - 1);
                            }}
                          />
                        </PaginationItem>
                        {pagination.pages.map((page, index) => (
                          <PaginationItem key={'_page_' + index} active={page === pagination.currentPage}>
                            <PaginationLink
                              onClick={(e) => {
                                paginate(page);
                              }}
                            >
                              {page}
                            </PaginationLink>
                          </PaginationItem>
                        ))}
                        <PaginationItem disabled={pagination.currentPage === pagination.totalPages}>
                          <PaginationLink
                            next
                            onClick={(e) => {
                              paginate(pagination.currentPage + 1);
                            }}
                          />
                        </PaginationItem>
                        <PaginationItem disabled={pagination.currentPage === pagination.totalPages}>
                          <PaginationLink
                            last
                            onClick={(e) => {
                              paginate(pagination.totalPages);
                            }}
                          />
                        </PaginationItem>
                      </Pagination>
                      <div className="records-count text-center">
                        <p>
                          Showing <strong>{pagination.startIndex + 1}</strong> to{' '}
                          <strong>{pagination.endIndex + 1}</strong> of <strong>{pagination.totalItems}</strong> records
                        </p>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <PopupAddStudyGuide show={isPopupOpen} toggleModal={toggleModal} />
    </React.Fragment>
  );
};

export default StudyGuideList;
